export const categories = {
  title: 'Categorías',
  description: 'Gestione sus categorías de productos',
  form: {
    createTitle: 'Nueva categoría',
    editTitle: 'Editar categoría',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      type: 'Tipo',
      parent: 'Categoría padre',
      isActive: 'Activo',
      image: 'Imagen'
    },
    placeholders: {
      name: 'Ingrese el nombre de la categoría',
      description: 'Ingrese la descripción de la categoría',
      parent: 'Seleccione una categoría padre',
      image: 'Seleccione una imagen'
    },
    validations: {
      required: 'Este campo es requerido',
      minLength: 'Este campo debe tener al menos {min} caracteres',
      maxLength: 'Este campo no debe exceder {max} caracteres'
    },
    create: 'Crear',
    update: 'Actualizar',
    cancel: 'Cancelar',
    submitting: 'Guardando...'
  },
  columns: {
    name: 'Nombre',
    description: 'Descripción',
    type: 'Tipo',
    parent: 'Categoría padre',
    isActive: 'Estado',
    image: 'Imagen',
    basicInfo: 'Información básica',
    createdAt: 'Creado el',
    updatedAt: 'Actualizado el',
    lastSync: 'Última sincronización'
  },
  filters: {
    search: {
      label: 'Buscar',
      placeholder: 'Buscar una categoría...'
    },
    type: {
      label: 'Tipo',
      product: 'Producto',
      service: 'Servicio'
    },
    status: {
      label: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo'
    }
  },
  actions: {
    newCategory: 'Nueva categoría',
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver'
  },
  confirmations: {
    delete: '¿Está seguro de que desea eliminar esta categoría?',
    deleteSuccess: 'Categoría eliminada con éxito',
    createSuccess: 'Categoría creada con éxito',
    updateSuccess: 'Categoría actualizada con éxito'
  },
  errors: {
    load: 'Error al cargar las categorías',
    create: 'Error al crear la categoría',
    update: 'Error al actualizar la categoría',
    delete: 'Error al eliminar la categoría',
    cannotDeleteWithProducts: "No se puede eliminar la categoría porque contiene productos",
    deleteError: "Error al eliminar la categoría"
  },
  pagination: {
    totalItems: 'Total de elementos',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    showing: 'Mostrando',
    to: 'a',
    of: 'de',
    items: 'elementos'
  }
}; 